import { render, staticRenderFns } from "./ProductDetailPage.vue?vue&type=template&id=7a820440&scoped=true&"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailPage.vue?vue&type=style&index=0&id=7a820440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a820440",
  null
  
)

export default component.exports